import { SET_TASK_NAME as type } from './';

export default payload => ({
  type,
  payload,
});
